var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-md-2" }, [
        _c("div", { staticClass: "ob1-skeleton" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white",
            staticStyle: { height: "70px" },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-10" }, [
        _c("div", { staticClass: "ob1-skeleton" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white",
            staticStyle: { height: "70px" },
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }